// Pages that only make sense signed out; signing in or up never returns to them.
const AUTH_PAGES = ['/signin', '/signup', '/forgot-password', '/reset-password']

export function isAuthPage (path) {
  return AUTH_PAGES.includes(path.split(/[?#]/)[0].replace(/(.)\/$/, '$1'))
}
